var React = require('react');

function SoundOnIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FFF","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M33 8c3.333862 2.6357808 6 7.0348292 6 11.49924C39 23.9575706 36.3227597 28.3626991 33 31M28 13c2.812376 1.6353954 5 4.0052119 5 7 0 2.9963743-2.1856406 5.3646046-5 7M10.2 13.9959929H3.4334c-1.6023333 0-2.4334 1.4939895-2.4334 3.1255009l.0996667 6.4197788c0 1.6330743 1.2987333 2.9567239 2.9010666 2.9567239h6.7666L24 39V0L10.2 13.9959929z"})));
}

SoundOnIcon.defaultProps = {"viewBox":"0 0 40 40"};

module.exports = SoundOnIcon;

SoundOnIcon.default = SoundOnIcon;
